import { Flex } from '@common/components/Flex';
import { WarningIcon } from '@common/components/warning-icon';

import './warning-message.styles.scss';

export const WarningMessage = (props) => {
	const { children } = props;

	return (
		<Flex className="WarningMessage">
			<WarningIcon margin="0 8px 0 0" />
			<div className="WarningMessage__children">{children}</div>
		</Flex>
	);
};